import { render, staticRenderFns } from "./SettingsCache.vue?vue&type=template&id=200c30c6&scoped=true&"
import script from "./SettingsCache.vue?vue&type=script&lang=js&"
export * from "./SettingsCache.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCache.vue?vue&type=style&index=0&id=200c30c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200c30c6",
  null
  
)

export default component.exports